import clsx from 'clsx';
import { CalculatingSpinner } from 'components/UI';
import { FunctionComponent } from 'react';
import styles from './TotalResumeLine.module.css';

export interface TotalResumeLineProps {
    description: string;
    value: string;
    loading?: boolean;
    className?: string;
}

export const TotalResumeLine: FunctionComponent<TotalResumeLineProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.leftContainer}>
                <span className={styles.text}>{props.description}</span>
            </div>
            <div className={styles.rightContainer}>
                {props.loading ? <CalculatingSpinner /> : <span className={styles.text}>{props.value}</span>}
            </div>
        </div>
    );
};

export default TotalResumeLine;
